import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {setObject} from "../../helpers/objectHelper";

export interface SessionDataModel {
    sessionSliceData:{[key:string]:any},
    sessionSliceStorageData:{[key:string]:any},

}
export type saveDataType = { name:string,value:any}
const getStorageData = () => {
    const ls = localStorage.getItem('storageData');
    try {
        if(ls !== null){
            return JSON.parse(ls);
        }
        return {};
    }
    catch {

    }
    return  {};

};
export const  defaultSessionDataModel:SessionDataModel={
    sessionSliceData:{},
    sessionSliceStorageData:{}

}


const initialState:SessionDataModel = {
    sessionSliceData:{},
    sessionSliceStorageData:getStorageData()
}

export const sessionDataSlice = createSlice({
    name: "sessionData",
    initialState: initialState,
    reducers: {
        setSessionData: (state, action: PayloadAction<saveDataType>) => {
            if(action.payload && action.payload.name)
            {
                state.sessionSliceData[action.payload.name]  = action.payload.value;
                //lsetObject(state.sessionSliceData,action.payload.name,action.payload.value,true);
            }
            return state;
        },
        setSessionStorageData: (state, action: PayloadAction<saveDataType>) => {
            if(action.payload && action.payload.name)
            {
                setObject(state.sessionSliceStorageData,action.payload.name,action.payload.value,true);
                localStorage.setItem("storageData",JSON.stringify(state.sessionSliceStorageData));
            }
            return state;
        },
        clearData: (state) => {
            state.sessionSliceData={};
        },
        clearStorageData: (state) => {
            state.sessionSliceStorageData={};
            localStorage.setItem("storageData","{}");
        },


    }
})

 export const { setSessionData, setSessionStorageData} = sessionDataSlice.actions;

export default sessionDataSlice.reducer;
